// frontend/src/pages/AnalysisPage/sections/ColumnMapping/FieldGroup.js
// Purpose: Display a group of related fields for column mapping

// Desired outcome: Provide a collapsible interface to organize fields into categories,
// making the mapping process more manageable for users

import React, { useState } from 'react';
import './FieldGroup.css';

const FieldGroup = ({ name, fields, columnOptions, mappings, onMappingChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  
  // Toggle expansion state
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  
  return (
    <div className={`field-group ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="field-group-header" onClick={toggleExpanded}>
        <h3>{name}</h3>
        <span className="toggle-icon">{isExpanded ? '▼' : '►'}</span>
      </div>
      
      {isExpanded && (
        <div className="field-group-content">
          <table className="mapping-table">
            <thead>
              <tr>
                <th>System Field</th>
                <th>Description</th>
                <th>File Column</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr key={index}>
                  <td className="field-name">{field.name}</td>
                  <td className="field-description">{field.description}</td>
                  <td>
                    <select 
                      value={mappings[field.name] || 'Use default values'}
                      onChange={(e) => onMappingChange(field.name, e.target.value)}
                      className="column-select"
                    >
                      {columnOptions.map((option, idx) => (
                        <option key={idx} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FieldGroup;